const EMPTY_PAYLOAD = {};
const JSON_START_CHARS = new Set(['{', '[', '"', '-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 't', 'f', 'n']);

export function parse_api_data(payload) {
  if (typeof payload !== 'string') return payload || {};
  return parse_json_payload(payload);
}

function parse_json_payload(payload) {
  return should_parse_json(payload) ? JSON.parse(payload) : EMPTY_PAYLOAD;
}

function should_parse_json(value = '') {
  return JSON_START_CHARS.has(String(value).trim().charAt(0));
}

export function response_items(response_data) {
  const data = parse_api_data(response_data);
  const nested_data = parse_api_data(data.data);
  if (Array.isArray(nested_data)) return nested_data;
  if (Array.isArray(data.data)) return data.data;
  return Array.isArray(data) ? data : [];
}
